import type {Row} from 'react-table'

export function applyGroupNameToRowId<T extends object>(item: Row<T>, groupName: string): Row<T> {
  return {...item, id: `${groupName}-${item.id}`}
}

export function groupNameFromRow<T extends object>(item: Row<T>): string {
  const {id} = item
  return id.slice(0, id.lastIndexOf('-'))
}
